import "./login.css";

const LoginPage = ({ inputs, handleChange, hanleSubmit, err }) => {
  return (
    <div>
      <div class="login-box">
        <h2>Login</h2>
        <p
          style={{
            backgroundColor: "white",
            color: "red",
            borderRadius: "8px",
            textTransform: "capitalize",
          }}
        >
          {err && err}
        </p>
        <form onSubmit={hanleSubmit}>
          <div class="user-box">
            <input
              type="text"
              name="email"
              onChange={handleChange}
              required
              value={inputs.email}
            />
            <label>email</label>
          </div>
          <div class="user-box">
            <input
              type="password"
              name="password"
              onChange={handleChange}
              required
              value={inputs.password}
            />
            <label>Password</label>
          </div>
          <input type="submit" value="submit" />
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
